import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-link-column',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './link-column.component.html',
  styleUrl: './link-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkColumnComponent {
  readonly label = input.required<string | null>();
  readonly routerLink = input.required<(string | null)[]>();
  readonly newTab = input<boolean>(false);

  readonly target = computed(() => {
    return this.newTab() ? '_blank' : '_self';
  });
}
